import { FC, Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FilterArr, TableCol, actionArr } from "./Data";
import { TableLayout } from "Layouts";
import { ControlledTable, Filter2 } from "Components";
import { RouteUrls } from "Constant/RouteUrls";
import PatientApi from "Service/Patient.api";
import Formate from "./Format";
import { Filter2DataProps } from "DataTypes/Common";
import { ScreenInitialStateType, UserInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { PendingCareType } from "DataTypes/Services/Patient.type";
import {
  CreateFilter2Payload,
  RedoxDataToFilter,
  TransformFilterDataRedox
} from "Utils/common";
import DateTime from "Utils/DateTime";
import UI from "Constant/UI";
import { useDispatch } from "react-redux";
import { setPageFilter, setPageLimit, setPageSort } from "Redux/Screen/Action";

const PendingCare: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const { listPagination, listFilters, listSort }: ScreenInitialStateType =
    useSelector((state: any) => state?.screen);
  const listObj = listFilters.find(el => el.id == "pending-care");
  const reduxLimit = (listPagination || []).find(
    el => el.id == "pending-care"
  )?.limit || 10;
  const reduxSortAsc = (listSort || []).find(
    el => el.id == "pending-care"
  )?.sortAsc;
  const currentMonth = DateTime.CurrentMonthName();
  const currentYear = DateTime.CurrentYear();
  const [rows, setRows] = useState<PendingCareType[]>([]);
  const [pageData, setPageData] = useState({
    ...UI.pageData,
    limit: reduxLimit
  });
  const [loading, setLoading] = useState(true);
  const [month, setMonth] = useState(currentMonth);
  const [year, setYear] = useState(currentYear);
  const [searchText, setSearchText] = useState("");
  const [filterHeight, setFilterHeight] = useState<number>(0);
  const [filterData, setFilterData] = useState<Filter2DataProps[]>(() =>
    RedoxDataToFilter(
      JSON.parse(JSON.stringify(FilterArr())),
      listObj
    ));
  const tableHeight = `calc(99% - ${filterHeight}px)`;
  const [sortType, setSortType] = useState(
    reduxSortAsc ?? true
  ); // true = "asc" & false = "desc"

  useEffect(() => {
    handleSetData(1, pageData.limit);
  }, [filterData, month, year, sortType]);

  const handleSetData: (
    currentPage: number,
    currentLimit: number
  ) => void = async (currentPage, currentLimit) => {
    setLoading(true);
    const newFilterPayload = CreateFilter2Payload(filterData);
    const payload = {
      ...(newFilterPayload || {}),
      month: DateTime.MonthNameToNumber(month),
      year: DateTime.YearToNumber(year),
    };
    let newPageData = { ...UI.pageData }
    let newRows: PendingCareType[] = [];
    const res = await PatientApi.PendingContinuous({
      offset: (currentPage - 1) * currentLimit,
      limit: currentLimit,
      data: payload,
      sortDirection: sortType ? "ASC" : "DESC"
    });
    if (res?.success) {
      newRows = Formate.PendingCareList(res?.data);
      newPageData = res.criterion;
    }
    setRows(newRows);
    setPageData(newPageData)
    dispatch(setPageLimit({ id: "pending-care", limit: newPageData.limit }));
    dispatch(setPageFilter({
      id: "pending-care",
      filterData: TransformFilterDataRedox(filterData)
    }));
    setLoading(false);
  };

  const handlePatientDetails: (data: PendingCareType) => void = (data) => {
    navigate(
      `../../${RouteUrls.patient}/${data.patientId}/${RouteUrls.details}`
    );
  };

  const handleChart: (data: PendingCareType) => void = (data) => {
    navigate(
      `../../${RouteUrls.patient}/${data.patientId}` +
      `/${RouteUrls.clinicalSummary}`
    );
  };

  const handleTask: (data: PendingCareType) => void = (data) => {
    navigate(
      `../../${RouteUrls.patient}/${data.patientId}` +
      `/${RouteUrls.task}/${RouteUrls.add}`
    );
  };

  const handleAddTimeLog: (data: PendingCareType) => void = (data) => {
    navigate(
      `../../${RouteUrls.patient}/${data.patientId}/${RouteUrls.addonTime}`
    );
  };

  const handleSortClick: () => void = () => {
    const newSortAsc = !sortType;
    setSortType(newSortAsc);
    dispatch(setPageSort({ id: "pending-care", sortAsc: newSortAsc }));
  };

  const TblBodyJSX = (
    <ControlledTable.TblBody
      tableColumn={() => TableCol(handleSortClick)}
      tableRow={rows}
      tableAction={(data: PendingCareType) =>
        actionArr(
          () => handleChart(data),
          () => handlePatientDetails(data),
          () => handleTask(data),
          () => handleAddTimeLog(data),
          myInfo.roleId
        )
      }
      searchText={searchText}
    />
  );

  return (
    <Fragment>
      <Filter2
        filterDataArr={filterData}
        handleFilterClick={(data) => setFilterData(data)}
        changeSearchText={(val) => setSearchText(val)}
        setFilterHeight={(val) => setFilterHeight(val)}
        monthChange={(val) => setMonth(val)}
        monthFilter={true}
        monthVal={month}
        yearChange={(val) => setYear(val)}
        yearFilter={true}
        yearVal={year}
      />
      <TableLayout
        tblBody={TblBodyJSX}
        tblHead={ControlledTable.TblHead(TableCol(handleSortClick))}
        height={tableHeight}
        loading={loading}
        pageRecordCount={rows.length}
        totalRecordCount={pageData.total}
        Pagination={
          <ControlledTable.Pagination
            mainPage={pageData.page}
            limit={pageData.limit}
            total={pageData.total}
            handleClick={handleSetData}
            tableStyle={true}
          />
        }
      />
    </Fragment>
  );
};
export default PendingCare;
